import styled from "styled-components";

/**
 * Wrapper principal do elemento de filtro.
 */
export const FilterElementWrapper = styled.div.withConfig({
  shouldForwardProp: (prop) => !["hasBorder"].includes(prop),
})<{ hasBorder?: boolean }>`
  border-bottom: ${({ hasBorder, theme }) =>
    hasBorder ? `1px dashed ${theme.colors.lightGray}` : "none"};
  padding: ${({ theme }) => theme.spacing(2)};
  gap: ${({ theme }) => theme.spacing(2)};
  flex-direction: column;
  display: flex;
  width: 100%;
`;

/**
 * Wrapper do título do filtro (ícone + texto).
 */
export const FilterTitleWrapper = styled.div`
  gap: ${({ theme }) => theme.spacing(2.5)};
  align-items: center;
  display: flex;
`;

export const SelectionActions = styled.div`
  gap: ${({ theme }) => theme.spacing(1.5)};
  margin-top: ${({ theme }) => theme.spacing(3)};
  align-items: center;
  display: flex;
`;

export const SelectionAction = styled.button`
  padding: 0;
  border: 0;
  background: transparent;
  color: ${({ theme }) => theme.colors.vividBlue};
  font-family: ${({ theme }) => theme.fonts.primary};
  font-size: ${({ theme }) => theme.fontSizes.sm};
  cursor: pointer;

  &:hover {
    color: ${({ theme }) => theme.colors.mediumBlue};
    text-decoration: underline;
  }
`;

export const SelectionDivider = styled.span`
  width: 1px;
  height: ${({ theme }) => theme.spacing(2)};
  background-color: ${({ theme }) => theme.colors.mediumGray};
`;

/**
 * Wrapper do corpo do filtro (conteúdo dinâmico).
 */
export const FilterBodyWrapper = styled.div`
  gap: ${({ theme }) => theme.spacing(2)};
  flex-direction: column;
  display: flex;
`;
